import { ConfigProvider, en, ru } from '@profgeosoft-ui/react';
import { observer } from 'mobx-react-lite';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import i18 from 'src/i18n';
import { Router } from 'src/router/router';

import { Loader } from './shared/components/loader';
import { LANGUAGES } from './shared/constants/languages';
import { RootStore, RootStoreProvider } from './store';

import styles from './app.module.scss';
import './styles/index.scss';

export const App = observer(function App() {
  const navigate = useNavigate();
  const [store] = useState(() => new RootStore({ navigate, i18 }));

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', store.theme.theme);
  }, [store.theme.theme]);

  useEffect(() => {
    const disposeStore = store.init();

    return () => {
      disposeStore();
    };
  }, [store]);

  const container = document.querySelector('body');

  useEffect(() => {
    container?.classList.add('container');
  }, [container]);

  if (!store.isInitialized || store.isLoading) {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <ConfigProvider
      config={{
        theme: store.theme.theme,
        size: 's',
        style: 'bordered',
        localization: store.language.language === LANGUAGES.ru ? ru : en,
      }}
      externalElement={container ?? undefined}
    >
      <RootStoreProvider store={store}>
        <Router />
      </RootStoreProvider>
    </ConfigProvider>
  );
});
